module.exports = __webpack_public_path__ + "img/20180414165834.2008e566.jpg";